import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import { Services } from './components/Services';
import { Frameworks } from './components/Frameworks';
import SocialProof from './components/SocialProof';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import AIAssessment from './components/AIAssessment';
import CookieBanner from './components/CookieBanner';
import GoogleAnalytics from './components/GoogleAnalytics';

// Assembles the full single-page experience in display order.
const App = () => {
  const path = typeof window !== 'undefined' ? window.location.pathname.toLowerCase() : '/';
  const normalizedPath = path === '/' ? '/' : path.replace(/\/+$/, '');

  if (['/ai-assessment', '/ai-assessment.html'].includes(normalizedPath)) {
    return (
      <>
        <AIAssessment />
        <GoogleAnalytics />
        <CookieBanner />
      </>
    );
  }

  if (['/privacy-policy', '/privacy-policy.html'].includes(normalizedPath)) {
    return (
      <>
        <PrivacyPolicy />
        <GoogleAnalytics />
        <CookieBanner />
      </>
    );
  }

  if (['/terms-of-service', '/terms-of-service.html', '/terms', '/terms.html'].includes(normalizedPath)) {
    return (
      <>
        <TermsOfService />
        <GoogleAnalytics />
        <CookieBanner />
      </>
    );
  }

  return (
    <>
      <div className="flex flex-col">
        <Navigation />
        <Hero />
        <Services />
        <Frameworks />
        <SocialProof />
        <About />
        <Contact />
        <Footer />
      </div>
      <GoogleAnalytics />
      <CookieBanner />
    </>
  );
};

export default App;
